import { Directive, ElementRef, NgZone, effect, EffectRef, inject } from '@angular/core';
import { ChartComponent } from '@progress/kendo-angular-charts';
import { ThemeService } from '../services/theme.service';

@Directive({
  selector: '[ChartThemeSync]',
  standalone: true
})
export class ChartThemeSyncDirective
{
  // Optional chart instance (directive may be on non-chart host)
  private readonly chart = inject(ChartComponent, { optional: true }) as any | null;
  private readonly hostRef = inject(ElementRef) as ElementRef<HTMLElement>;
  private readonly theme = inject(ThemeService);
  private readonly ngZone = inject(NgZone);

  // Create the effect within the directive's injection context
  private readonly syncEffect: EffectRef = effect(() =>
  {
    const _dark = this.theme.isDarkEffective();
    const _seq = this.theme.kendoThemeLoadSeq();

    this.ngZone.runOutsideAngular(() =>
    {
      requestAnimationFrame(() =>
        requestAnimationFrame(() =>
        {
          try
          {
            const host: HTMLElement | undefined =
              this.hostRef?.nativeElement ?? this.chart?.element?.nativeElement;
            if (host) { getComputedStyle(host).getPropertyValue('color'); }
          } catch { /* ignore */ }

          const c = this.chart;
          if (c)
          {
            if (typeof c.reloadTheme === 'function') c.reloadTheme();
            else if (typeof c.refresh === 'function') c.refresh();
            else if (typeof c.redraw === 'function') c.redraw();

            setTimeout(() =>
            {
              if (typeof c.resize === 'function') c.resize();
            }, 0);
          }
        }));
    });
  });
}
